import { Component, OnInit, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatTable, MatTableDataSource, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-view-service-clients-modal',
    standalone: true,
    templateUrl: './view-service-clients-modal.component.html',
    styleUrls: ['./view-service-clients-modal.component.scss'],
    imports: [
        MatDialogModule,
        MatButtonModule,
        MatTable,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatCellDef,
        MatCell,
        MatHeaderRowDef,
        MatHeaderRow,
        MatRowDef,
        MatRow,
        MatIcon
    ]

})
export class ViewServiceClientsModalComponent {
  dialogRef = inject<MatDialogRef<ViewServiceClientsModalComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  displayedColumns: string[] = ['code', 'title', 'description'];
  selectedService: any = {};

  constructor() {
      const data = this.data;

      const clientList = data.clientList || [];
      this.selectedService = data.selectedService;
      this.dataSource.data = clientList.filter((cl: any) => cl.services[this.selectedService.primaryKeyPart]);
     }

}
